import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContractSignMode } from 'src/app/shared/enums/ContractSignMode.enum';
import { LaftStatus } from 'src/app/shared/enums/LaftStatus.enum';
import { SignDocumentTypes } from './sign-document-types.enum';
import { ContractService } from 'src/app/shared/services/contract.service';
export interface ChooseDocumentsSignPopupData {
  laftStatus?: string;
}

export interface OptionConfig {
  title: string;
  description: string;
  options?: { label: string; value: boolean; isDisabled?: boolean; selectedValue: string }[];
}

@Component({
  selector: 'app-choose-documents-sign-popup',
  templateUrl: './choose-documents-sign-popup.component.html',
  styleUrls: ['./choose-documents-sign-popup.component.scss'],
})
export class ChooseDocumentsSignPopupComponent implements OnInit {
  option1Config: OptionConfig;
  option2Config: OptionConfig;
  @Output() selectOptionEvent = new EventEmitter();
  @Output() drawerOpened = new EventEmitter();
  hasLaftStarted = false;
  wasDrawerOpened = false;
  isDrawerButtonDisabled = true;

  constructor(
    public dialogRef: MatDialogRef<ChooseDocumentsSignPopupComponent>,
    private contractService: ContractService,
    @Inject(MAT_DIALOG_DATA) public data: ChooseDocumentsSignPopupData = {}
  ) {}

  ngOnInit(): void {
    this.hasLaftStarted = this.data?.laftStatus !== '' && this.data?.laftStatus !== LaftStatus.Pending;
    this.buildOptionsConfig();
  }

  private buildOptionsConfig(signModeResponse?: { contractSignMode?: ContractSignMode }): void {
    const mode = signModeResponse?.contractSignMode ?? ContractSignMode.Default;
    const contractOptions = this.buildContractOptions(mode);

    if (this.hasLaftStarted) {
      this.option1Config = {
        title: 'Solo contrato',
        description: 'Firma únicamente el contrato de Factoring/Confirming.',
        options: contractOptions,
      };
    } else {
      this.option1Config = {
        title: 'Contrato + Declaración jurada',
        description: 'Firma ambos documentos con un solo paso.',
        options: [
          {
            label: 'Declaración jurada',
            value: true,
            isDisabled: true,
            selectedValue: SignDocumentTypes.DECLARACION_JURADA,
          },
          ...contractOptions,
        ],
      };
    }

    this.option2Config = {
      title: 'Solo Declaración Jurada',
      description: 'Firma solo la declaración jurada para empezar la validación LAFT.',
    };
  }

  private buildContractOptions(mode: ContractSignMode): NonNullable<OptionConfig['options']> {
    // Confirming clients sign confirming and nothing else; Rextie clients can
    // only sign factoring, so confirming is not offered to them at all.
    const isConfirmingForced = mode === ContractSignMode.Confirming;
    const isConfirmingHidden = mode === ContractSignMode.Rextie;

    const options: NonNullable<OptionConfig['options']> = [
      {
        label: 'Contrato de Factoring',
        value: isConfirmingHidden,
        isDisabled: isConfirmingHidden,
        selectedValue: SignDocumentTypes.FACTORING,
      },
    ];

    if (!isConfirmingHidden) {
      options.push({
        label: 'Contrato de Confirming',
        value: isConfirmingForced,
        isDisabled: isConfirmingForced,
        selectedValue: SignDocumentTypes.CONFIRMING,
      });
    }

    return options;
  }

  get djSigned(): boolean {
    return this.data?.laftStatus === LaftStatus.Completed;
  }

  /**
   * FIN-1729: el cliente ya no puede elegir firmar solo la Declaración jurada.
   * La tarjeta sobrevive únicamente como indicador de "DJ ya firmada" (FIN-1318 AC 1.2),
   * nunca como una opción de firma seleccionable.
   */
  get showDeclaracionJuradaIndicator(): boolean {
    return this.djSigned;
  }

  onBack(): void {
    this.dialogRef.close();
  }

  handleOptionSelected(selectedOptions: []) {
    this.selectOptionEvent.emit(selectedOptions);
  }

  handleDrawerOpen() {
    if (!this.wasDrawerOpened) {
      this.contractService.getContractSignMode().subscribe((response: any) => {
        this.wasDrawerOpened = true;
        this.isDrawerButtonDisabled = false;
        this.buildOptionsConfig(response);
      });
    }
  }
}
